// 客户端技术指标工具

// 神奇9转计数：返回每根蜡烛的计数数组
// 正值 = 上涨计数（顶部风险方向），负值 = 下跌计数（底部机会方向），0 = 无
// 1-9 为一个周期，满 9 后下一根符合条件的 K 线重新从 1 开始计数（不出现 9,9,9 重复）
export function tdCounts(closes: number[]): number[] {
  const out: number[] = new Array(closes.length).fill(0);
  let up = 0;
  let down = 0;
  for (let i = 4; i < closes.length; i++) {
    const c = closes[i]!;
    const p = closes[i - 4]!;
    if (c > p) {
      up = up >= 9 ? 1 : up + 1;
      down = 0;
      out[i] = up;
    } else if (c < p) {
      down = down >= 9 ? 1 : down + 1;
      up = 0;
      out[i] = -down;
    } else {
      up = 0;
      down = 0;
    }
  }
  return out;
}
